import { render } from "./Recuperar.vue?vue&type=template&id=24372092&scoped=true"
import script from "./Recuperar.vue?vue&type=script&lang=js"
export * from "./Recuperar.vue?vue&type=script&lang=js"

import "./Recuperar.vue?vue&type=style&index=0&id=24372092&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24372092"]])

export default __exports__